import { z } from 'zod';

export const FeedbackType = {
  GENERAL: 'general',
  INSPECTION_REPORT: 'inspection_report',
  CONTACT_QUERY: 'contact_query',
} as const;

export type FeedbackTypeValue = (typeof FeedbackType)[keyof typeof FeedbackType];

export const FeedbackStatus = {
  READ: 'read',
  UNREAD: 'unread',
} as const;

export type FeedbackStatusValue = (typeof FeedbackStatus)[keyof typeof FeedbackStatus];

export const CreateFeedbackRequestSchema = z.object({
  type: z.enum(['general', 'inspection_report']),
  referenceId: z.string().optional(),
  rating: z.number().int().min(1).max(5).optional(),
  message: z.string().min(1).max(2000),
});

export type CreateFeedbackRequest = z.infer<typeof CreateFeedbackRequestSchema>;
export type SubmitFeedbackResponse = { feedbackId: number };

export const SubmitContactQueryRequestSchema = z.object({
  name: z.string().min(1).max(100),
  email: z.string().email().optional(),
  phone: z.string().optional(),
  message: z.string().min(1).max(4000),
});

export type SubmitContactQueryRequest = z.infer<typeof SubmitContactQueryRequestSchema>;

export const UpdateFeedbackStatusRequestSchema = z.object({
  status: z.enum(['read', 'unread']),
});

export type UpdateFeedbackStatusRequest = z.infer<typeof UpdateFeedbackStatusRequestSchema>;

export const FeedbackListItemSchema = z.object({
  id: z.number(),
  userId: z.string().nullable(),
  type: z.enum(['general', 'inspection_report', 'contact_query']),
  referenceId: z.string().nullable(),
  rating: z.number().nullable(),
  name: z.string().nullable(),
  email: z.string().nullable(),
  phone: z.string().nullable(),
  message: z.string().nullable(),
  status: z.enum(['read', 'unread']),
  createdAt: z.string(),
});

export type FeedbackListItem = z.infer<typeof FeedbackListItemSchema>;

export const FeedbackListResponseSchema = z.object({
  items: z.array(FeedbackListItemSchema),
});

export type FeedbackListResponse = z.infer<typeof FeedbackListResponseSchema>;
